import { create } from "zustand";

const useSearchBarOpenState = create((set) => ({
  isSearchBarOpen: false,
  setIsSearchBarOpen: (newIsSearchBarOpen) =>
    set(() => ({ isSearchBarOpen: newIsSearchBarOpen })),
}));

export default useSearchBarOpenState;
